"use strict";

module.exports = /*@ngInject*/function () {
  return {
    restrict: 'AE',
    scope: true,
    bindToController: {
      image: '=',
      canRemove: '=',
      remove: '&',
      isPublicView: '=',
      shareableToken: '='
    },
    template: "\n      <div class=\"lightbox\" ng-click=\"$ctrl.image = null\">\n          <div class=\"container\">\n            <img id=\"lightboxImage\" ng-src=\"{{ $ctrl.image.$$signedUrl }}\" ng-show=\"$ctrl.image.$$signedUrl\"/>\n            <div class=\"loading-card\" ng-if=\"$ctrl.loading\">\n              <i class=\"glyphicon glyphicon-repeat spin\"></i> Loading ...\n            </div>\n            <div class=\"image-footer\">\n                <button ng-if=\"$ctrl.canRemove && !$ctrl.isPublicView\" ng-click=\"$ctrl.remove()($ctrl.image)\" class=\"btn btn-danger pull-left\"> <i class=\"glyphicon glyphicon-trash\"></i>Delete</button>\n                <span class=\"pull-right\">\n                  <a href=\"{{$ctrl.image.$$signedUrl}}\" ng-if=\"$ctrl.image.$$signedUrl\">\n                    <button  class=\"btn btn-default\"><i class=\"glyphicon glyphicon-download\"></i>Download</button>\n                  </a>\n                  <button ng-click=\"$ctrl.image = null\" class=\"btn btn-default\"> <i class=\"glyphicon glyphicon-remove\"></i>Close</button>\n                </span>\n            </div>\n          </div>\n      </div>\n    ",
    controllerAs: '$ctrl',
    // eslint-disable-next-line object-shorthand
    controller: /*@ngInject*/function controller(ReportService, Upload, $http) {
      var ctrl = this;
      ctrl.$onInit = function () {
        if (!ctrl.image.$$signedUrl) {
          ctrl.loading = true;
          $http.get("api/report/attachment/".concat(ctrl.image.s3Name, "/download")).then(function (res) {
            ctrl.image.$$signedUrl = res.data.signedUrl;
            ctrl.loading = false;
          });
        }
      };
    }
  };
};